import { api } from "@/api"
import type { User } from "@/composables/useCurrentUser"

const { setToken } = useAuth()
const { setUser } = useCurrentUser()

export const logInBasic = async (params: {
  tenantIdentifier: string
  email: string
  password: string
}) => {
  const {
    body: { accessToken, user },
  } = await api.post<{
    accessToken: string
    user: User
  }>("/auth/user-login/", {
    body: {
      email: params.email,
      password: params.password,
      merchantId: params.tenantIdentifier,
    },
    headers: {
      "X-DT-SCHEMA": "public",
    },
    authenticated: false,
  })

  setUser(user)
  setToken(accessToken)
  return { accessToken, user }
}
